import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { formatSnakeCaseToGeneral } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import {
  ExpenseOption,
  ExpensesDetailsParams,
} from '@/modules/transaction/transaction.types';

const EXPENSES_STATISTICS_QUERY_KEY = 'getExpensesStatisticsQueryKey';
const OTHER_EXPENSE = {
  key: 'OTHER',
  title: 'Other',
};

export const useExpensesStatisticsQuery = (params?: ExpensesDetailsParams) => {
  const accountId = params?.account_id;
  const { data, isLoading, isSuccess, refetch } = useQuery([EXPENSES_STATISTICS_QUERY_KEY, accountId], () =>
    api.get(API_URL.EXPENSES_STATISTICS, { params })
  );
  const formattedData = useMemo(() => {
    const receivedData = data?.data;

    return {
      totalExpenses: Math.abs(receivedData?.total_expenses || 0),
      expenses: receivedData?.expenses?.map((listItem): ExpenseOption => {
        if (!listItem?.category_type) {
          return {
            ...OTHER_EXPENSE,
            value: listItem?.percent || 0,
            amount: listItem?.amount,
          };
        }
        return {
          key: listItem?.category_type || '',
          title: formatSnakeCaseToGeneral(listItem?.category_type || ''),
          value: listItem?.percent || 0,
          amount: Math.abs(listItem?.amount || 0) || 0,
        };
      }),
    };
  }, [data]);
  return {
    formattedData,
    isLoading,
    isSuccess,
    data,
    refetch,
  };
};
